module.exports = __webpack_public_path__ + "img/__icon_SZTYWNA ZABUDOWA.da46bcc1.svg";